export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '喜剧', icon: 'ri-emotion-happy-line' },
  { slug: 'horror', name: '恐怖', icon: 'ri-ghost-line' },
];

export const comics = [
  {
    id: 1,
    title: '女神降临',
    author: 'Yaongyi',
    category: 'romance',
    rating: 9.5,
    chapters: 248,
    status: 'completed',
    description: '平凡女孩通过化妆技巧逆袭成为校园女神，却陷入了两个男神之间的甜蜜恋爱漩涡。这部韩国漫画以其精美的画风和真实的青春故事，吸引了全球无数读者。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20young%20woman%20with%20long%20dark%20hair%2C%20elegant%20makeup%2C%20soft%20romantic%20atmosphere%2C%20pastel%20color%20palette%2C%20clean%20anime%20art%20style%2C%20webtoon%20cover%20design%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    updateDate: '2026-08-03',
    tags: ['恋爱', '校园', '逆袭', '人气'],
    isHot: true,
  },
  {
    id: 2,
    title: '全知读者视角',
    author: 'sing N song',
    category: 'fantasy',
    rating: 9.7,
    chapters: 312,
    status: 'ongoing',
    description: '唯一知道世界末日真相的读者，在末日开始后凭借对小说的了解展开生存之旅。这部现象级韩国漫画融合了奇幻、冒险与悬疑元素。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20illustration%20of%20a%20young%20man%20in%20dark%20coat%20holding%20a%20glowing%20book%2C%20apocalyptic%20atmosphere%2C%20dramatic%20lighting%2C%20mysterious%20vibe%2C%20webtoon%20cover%20art%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    updateDate: '2026-08-04',
    tags: ['奇幻', '冒险', '末世', '人气'],
    isHot: true,
  },
  {
    id: 3,
    title: '我独自升级',
    author: 'Chugong',
    category: 'action',
    rating: 9.8,
    chapters: 200,
    status: 'completed',
    description: '最弱猎人获得神秘系统后一步步成长为最强猎人的故事。震撼的战斗场面和爽快的升级体验，让它成为全球最受欢迎的韩国漫画之一。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20aura%2C%20purple%20and%20black%20color%20scheme%2C%20dynamic%20pose%2C%20shadow%20army%20behind%2C%20epic%20webtoon%20cover%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    updateDate: '2026-07-28',
    tags: ['动作', '奇幻', '升级', '人气'],
    isHot: true,
  },
  {
    id: 4,
    title: '甜蜜的家庭',
    author: 'Kim Carnby',
    category: 'thriller',
    rating: 9.4,
    chapters: 160,
    status: 'completed',
    description: '被怪物包围的公寓中，幸存者们为生存而战。这部悬疑恐怖韩国漫画以其紧张刺激的剧情和深刻的人性刻画而闻名。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20dark%20apartment%20building%20with%20monster%20silhouettes%2C%20tense%20atmosphere%2C%20horror%20mood%2C%20dark%20color%20tones%2C%20webtoon%20cover%20design%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    updateDate: '2026-08-01',
    tags: ['悬疑', '恐怖', '生存', '人气'],
    isHot: false,
  },
  {
    id: 5,
    title: '犬系恋人',
    author: 'Lee Hye',
    category: 'romance',
    rating: 9.1,
    chapters: 120,
    status: 'completed',
    description: '拥有一条会变成人的狗狗的女孩，经历了一段不可思议的浪漫爱情。温暖治愈的韩国漫画，画风细腻柔美，触动人心的纯爱故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20sweet%20young%20couple%20with%20a%20cute%20dog%2C%20warm%20sunlight%2C%20soft%20pastel%20tones%2C%20healing%20atmosphere%2C%20webtoon%20cover%20art%2C%20simple%20light%20gradient%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    updateDate: '2026-07-25',
    tags: ['恋爱', '治愈', '奇幻'],
    isHot: false,
  },
  {
    id: 6,
    title: '梨泰院Class',
    author: 'Kwang Jin',
    category: 'drama',
    rating: 9.3,
    chapters: 180,
    status: 'completed',
    description: '在梨泰院开餐厅的年轻人，用自己的方式向不公的世界复仇。热血励志的韩国漫画，展现小人物逆袭的精彩人生故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20a%20determined%20young%20man%20in%20front%20of%20a%20restaurant%20at%20night%2C%20city%20lights%2C%20warm%20neon%20tones%2C%20slice%20of%20life%20mood%2C%20webtoon%20cover%2C%20simple%20night%20gradient%20background&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    updateDate: '2026-07-30',
    tags: ['剧情', '励志', '复仇', '人气'],
    isHot: true,
  },
  {
    id: 7,
    title: '看脸时代',
    author: 'Park Taejun',
    category: 'drama',
    rating: 9.2,
    chapters: 460,
    status: 'ongoing',
    description: '一个拥有两具身体的胖少年，体验着截然不同的人生。这部韩国漫画深刻探讨了外貌歧视、校园霸凌等社会议题。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20illustration%20of%20a%20split%20face%20half%20handsome%20half%20ordinary%20young%20man%2C%20dramatic%20contrast%2C%20school%20setting%2C%20social%20commentary%2C%20webtoon%20cover%20design%2C%20simple%20split%20gradient%20background&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    updateDate: '2026-08-04',
    tags: ['剧情', '校园', '社会'],
    isHot: false,
  },
  {
    id: 8,
    title: '剑尊归来',
    author: 'Jung Seonyul',
    category: 'action',
    rating: 9.0,
    chapters: 95,
    status: 'ongoing',
    description: '传说中的剑术大师在现代转世重生，以超强实力碾压各路高手。爽快刺激的韩国动作漫画，华丽的剑术对决令人欲罢不能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20swordsman%20with%20flowing%20robes%20in%20modern%20city%2C%20dynamic%20sword%20pose%2C%20martial%20arts%20vibe%2C%20cool%20color%20scheme%2C%20webtoon%20cover%20art%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    updateDate: '2026-08-03',
    tags: ['动作', '奇幻', '转世'],
    isHot: false,
  },
  {
    id: 9,
    title: '她的私生活',
    author: 'Kim Sungyeon',
    category: 'comedy',
    rating: 8.9,
    chapters: 88,
    status: 'completed',
    description: '美术馆策展人白天是职场精英，晚上却是爱豆狂热粉丝。这部韩国漫画以搞笑的方式描绘了追星族的双面人生。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20stylish%20career%20woman%20holding%20fan%20merchandise%2C%20fun%20and%20lively%20mood%2C%20bright%20pastel%20colors%2C%20playful%20webtoon%20cover%2C%20simple%20light%20gradient%20background&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    updateDate: '2026-07-20',
    tags: ['喜剧', '恋爱', '职场'],
    isHot: false,
  },
  {
    id: 10,
    title: '鬼灭之刃外传',
    author: 'Gotouge',
    category: 'action',
    rating: 9.6,
    chapters: 65,
    status: 'ongoing',
    description: '在恶鬼横行的世界中，少年剑士为了拯救变成鬼的妹妹而踏上斩鬼之旅。韩国漫画版的日式奇幻冒险，热血与温情并存。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20action%20illustration%20of%20a%20young%20swordsman%20with%20green%20and%20black%20checkered%20haori%2C%20water%20breathing%20effect%2C%20dynamic%20battle%20pose%2C%20traditional%20Japanese%20elements%2C%20webtoon%20cover%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    updateDate: '2026-08-02',
    tags: ['动作', '奇幻', '热血'],
    isHot: true,
  },
  {
    id: 11,
    title: '不良少年',
    author: 'Park Jaebum',
    category: 'action',
    rating: 8.8,
    chapters: 210,
    status: 'completed',
    description: '转学到问题高中后，主角凭借超强实力统一了学校的各方势力。经典韩国校园动作漫画，热血澎湃的青春物语。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20action%20illustration%20of%20a%20tough%20high%20school%20student%20in%20uniform%20with%20determined%20expression%2C%20school%20backdrop%2C%20fighting%20spirit%2C%20webtoon%20cover%20design%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    updateDate: '2026-07-15',
    tags: ['动作', '校园', '热血'],
    isHot: false,
  },
  {
    id: 12,
    title: '奇幻世界之旅',
    author: 'Lee Seungmin',
    category: 'fantasy',
    rating: 9.0,
    chapters: 145,
    status: 'ongoing',
    description: '普通上班族意外穿越到奇幻世界，利用现代知识在这个魔法世界中闯出一片天地。脑洞大开的韩国奇幻漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20man%20in%20modern%20clothes%20surrounded%20by%20magical%20elements%2C%20isekai%20theme%2C%20vibrant%20colors%2C%20fantasy%20world%2C%20webtoon%20cover%20art%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    updateDate: '2026-08-03',
    tags: ['奇幻', '冒险', '穿越'],
    isHot: false,
  },
  {
    id: 13,
    title: '心跳加速',
    author: 'Choi Miae',
    category: 'romance',
    rating: 9.3,
    chapters: 98,
    status: 'ongoing',
    description: '心脏科医生与病患之间展开的感人爱情故事。温柔细腻的韩国恋爱漫画，细腻描绘了医患之间的美好情感。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20a%20handsome%20doctor%20and%20a%20beautiful%20patient%2C%20hospital%20setting%2C%20warm%20emotional%20atmosphere%2C%20soft%20lighting%2C%20webtoon%20cover%2C%20simple%20warm%20gradient%20background&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    updateDate: '2026-08-01',
    tags: ['恋爱', '医疗', '治愈'],
    isHot: false,
  },
  {
    id: 14,
    title: '暗黑之城',
    author: 'Yoon Taesung',
    category: 'thriller',
    rating: 9.1,
    chapters: 78,
    status: 'ongoing',
    description: '城市中系列神秘失踪案背后隐藏着惊天秘密，主角一步步揭开真相。气氛紧张的韩国悬疑漫画，环环相扣的推理让人欲罢不能。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20illustration%20of%20a%20detective%20in%20dark%20alley%20with%20flashlight%2C%20noir%20atmosphere%2C%20rainy%20night%2C%20mysterious%20mood%2C%20webtoon%20cover%20design%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    updateDate: '2026-07-28',
    tags: ['悬疑', '推理', '都市'],
    isHot: false,
  },
  {
    id: 15,
    title: '美食的俘虏',
    author: 'Shim Jiho',
    category: 'comedy',
    rating: 8.7,
    chapters: 132,
    status: 'completed',
    description: '美食评论家意外拥有了味觉超能力，尝遍各地美食的同时展开了一系列爆笑冒险。轻松愉快的韩国美食喜剧漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20illustration%20of%20a%20happy%20food%20critic%20surrounded%20by%20delicious%20Korean%20dishes%2C%20bright%20and%20colorful%2C%20fun%20atmosphere%2C%20webtoon%20cover%20art%2C%20simple%20bright%20gradient%20background&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    updateDate: '2026-07-10',
    tags: ['喜剧', '美食', '冒险'],
    isHot: false,
  },
  {
    id: 16,
    title: '少女的世界',
    author: 'Morang',
    category: 'drama',
    rating: 9.4,
    chapters: 185,
    status: 'completed',
    description: '四个性格迥异的少女在高中相遇，一起经历了友情、爱情与成长的青春故事。温暖走心的韩国校园漫画，引发无数读者共鸣。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20drama%20illustration%20of%20four%20diverse%20high%20school%20girls%20laughing%20together%2C%20friendship%20theme%2C%20cherry%20blossoms%2C%20youthful%20vibe%2C%20webtoon%20cover%2C%20simple%20pink%20gradient%20background&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    updateDate: '2026-07-22',
    tags: ['剧情', '校园', '友情'],
    isHot: false,
  },
  {
    id: 17,
    title: '灵气复苏',
    author: 'Kim Hyunsoo',
    category: 'fantasy',
    rating: 9.2,
    chapters: 110,
    status: 'ongoing',
    description: '灵气复苏时代，普通人觉醒超能力后在这个剧变的世界中求生。宏大的世界观设定让这部韩国奇幻漫画脱颖而出。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20illustration%20of%20a%20young%20man%20with%20glowing%20energy%20powers%2C%20modern%20city%20with%20supernatural%20elements%2C%20epic%20scale%2C%20webtoon%20cover%20design%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    updateDate: '2026-08-04',
    tags: ['奇幻', '冒险', '异能'],
    isHot: false,
  },
  {
    id: 18,
    title: '花美男乐队',
    author: 'Jung Hyunjung',
    category: 'romance',
    rating: 8.9,
    chapters: 95,
    status: 'completed',
    description: '五个帅气男孩组成乐队追逐音乐梦想的故事，同时展开了一段段浪漫的恋爱。音乐与爱情交织的韩国漫画佳作。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20illustration%20of%20five%20handsome%20young%20men%20with%20musical%20instruments%2C%20band%20theme%2C%20stage%20lights%2C%20energetic%20mood%2C%20webtoon%20cover%20art%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    updateDate: '2026-07-18',
    tags: ['恋爱', '音乐', '青春'],
    isHot: false,
  },
  {
    id: 19,
    title: '午夜怪谈',
    author: 'Oh Seongdae',
    category: 'horror',
    rating: 8.8,
    chapters: 67,
    status: 'ongoing',
    description: '都市传说中的恐怖故事一一成真，主角需要在每个夜晚的恐怖事件中活下来。令人毛骨悚然的韩国恐怖漫画。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20illustration%20of%20a%20terrified%20face%20with%20ghostly%20shadow%2C%20dark%20midnight%20setting%2C%20creepy%20atmosphere%2C%20horror%20webtoon%20cover%2C%20simple%20dark%20gradient%20background&width=600&height=800&seq=comic-cover-19&orientation=portrait',
    updateDate: '2026-08-02',
    tags: ['恐怖', '都市传说', '灵异'],
    isHot: false,
  },
  {
    id: 20,
    title: '武林学校',
    author: 'Jeon Geukjin',
    category: 'action',
    rating: 9.0,
    chapters: 155,
    status: 'ongoing',
    description: '现代校园中隐藏的武林高手们展开的激烈对决。将传统武术与现代校园完美融合的韩国动作漫画，打斗场面精彩绝伦。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20illustration%20of%20a%20martial%20arts%20student%20in%20school%20uniform%20with%20fighting%20stance%2C%20martial%20arts%20theme%2C%20dynamic%20movement%2C%20webtoon%20cover%20design%2C%20simple%20gradient%20background&width=600&height=800&seq=comic-cover-20&orientation=portrait',
    updateDate: '2026-08-03',
    tags: ['动作', '校园', '武术'],
    isHot: false,
  },
];

export const heroComics = comics.filter(c => c.isHot).slice(0, 3);

export const banners = [
  {
    id: 1,
    title: '夏日韩漫盛宴',
    subtitle: '百部热门韩国漫画免费畅读',
    bgImage: 'https://readdy.ai/api/search-image?query=Artistic%20abstract%20composition%20with%20warm%20orange%20and%20coral%20gradients%2C%20flowing%20dynamic%20shapes%2C%20Korean%20manhwa%20inspired%20aesthetic%2C%20modern%20clean%20design%2C%20soft%20textures%2C%20cinematic%20lighting%2C%20elegant%20atmosphere&width=1600&height=700&seq=hero-bg-01&orientation=landscape',
    link: '/category/all',
  },
];